import * as service from 'state/services/teamService';
import * as types from './types';

export const getTeamFeatures = () => {
  return {
    type: types.GET_FEATURES,
    payload: service.fetchTeamFeatures(),
  };
};



// WEBPACK FOOTER //
// ./src/state/reducers/team/teamActions.js